var ani = {
	orientation : function(){
		//--------------------------------------------
		//! ORIENTATION LOCK
		//--------------------------------------------
		ani.orientationAnim = new TimelineMax( { delay:0, repeat:0 } )
			.set($(dom.orientationLock.main),{ display :'none'} )
			.fromTo($(dom.orientationLock.main),0.3,{autoAlpha:0,force3D:true, ease:Power4.easeOut},{autoAlpha:1,display:'flex',force3D:true, ease:Power4.easeOut })
			.fromTo($(dom.orientationLock.icon),0.3,{transformOrign:'50% 50%', opacity:0.5,rotation:90,force3D:true, ease:Power4.easeOut },{delay:0.3,transformOrign:'50% 50%', opacity:1,rotation:0,force3D:true, ease:Power4.easeOut })
			.seek(0).pause();	
		//--------------------------------------------

	},

	preloader:function() {
	
		//--------------------------------------------
		//! PRELOADER
		//--------------------------------------------
			ani.thisPage = dom.page.preloader;
			
			// OUT
			ani.preloaderOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
					
					.to($(ani.thisPage + ' .icon--headphones'), 0.25, {alpha: 0, force3D:true, ease:Power4.easeOut})
					.to($(ani.thisPage), 0.6, {autoAlpha:0, backgroundSize:'150%, 150%', force3D:true, ease:Power4.easeOut})
				
				.seek(0).pause();
			
			// IN
			ani.preloaderIn = new TimelineMax({delay:0, repeat:0, onComplete:function(){ app.dispatcher.dispatch(EVENTS.INTRO_PRELOAD_READY) } })
				
				.set( $(dom.logo.ele + ' .grp1'), {clearProps: 'all'} )
				.set( $(dom.logo.ele + ' .grp2'), {clearProps: 'all'} )
				.set( $(dom.logo.ele + ' .grp3'), {clearProps: 'all'} )
				.set( $(dom.logo.ele + ' .grp4'), {clearProps: 'all'} )
				.set( $(dom.titles),{scale: 1.4, y: -5, autoAlpha: 0} )
				.set( $(dom.logo.ele),{scale: 0.9, autoAlpha: 0})
				.set( $(ani.thisPage + ' .icon--headphones'),{alpha: 0})
				.add(function(){preload.subPixelFix($('#js-preload-cta .btn--wide__text'))},0)
				.to( $(dom.titles), 0.5, {scale: 1, y: 0, autoAlpha: 1, force3D:true, ease:Power4.easeOut})
				.to( $(dom.logo.ele), 0.5, {scale: 1, autoAlpha: 1, force3D:true, ease:Power4.easeOut})
				.to( $(ani.thisPage + ' .icon--headphones'), 0.45, {alpha: 1, force3D:true, ease:Power4.easeOut})
			.seek(0).pause();
			
		//--------------------------------------------
		//! Preloader text
		//--------------------------------------------
			ani.preloadReady = new TimelineMax({delay:0, repeat:0})
			
				.to($(dom.preloader.percent), 0.25, {scale: 0.9, autoAlpha: 0, force3D:true})
				.set($(dom.logo.text), {display: 'block'})
				.from($(dom.logo.text), 0.25, {scale: 0.9, autoAlpha: 0, force3D:true})
				.set($(dom.logo.ele), {className:'-=is-ani'})
		
				.seek(0).pause();
				
		//--------------------------------------------
		//! RECIEVE
		//--------------------------------------------
			ani.thisPage = $('#js-pg-recived');
			
			// IN
			ani.recieveIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
				
				.set($(dom.recieve.text), {opacity:0})
				.set($(dom.recieve.button), {autoAlpha: 0, y: +40, scale: 0.8})
				
				.to($(dom.logo.ele + ' .grp1'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp2'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp3'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp4'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.recieve.button), 0.25, {autoAlpha:1, y: 0, force3D:true, ease:Power4.easeOut})
				.to($(dom.recieve.button), 0.25, {scale: 1, force3D:true, ease:Power4.easeOut})
				.fromTo($(dom.recieve.text), 0.3, {opacity:0, force3D:true},{opacity:1 , ease:Power4.easeIN}, "+=0.7")
				.to($(dom.recieve.text), 0.9, {opacity:0 , ease:Power4.easeOut}, "+=3")

			.seek(0).pause();
			
		//--------------------------------------------
		//! LANDING
		//--------------------------------------------
			ani.thisPage = $('#js-pg-landing');
			
			// IN
			ani.landingIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
				
				.set($(dom.logo.ele + ' .grp1'), {clearProps: 'all'})
				.set($(dom.logo.ele + ' .grp2'), {clearProps: 'all'})
				.set($(dom.logo.ele + ' .grp3'), {clearProps: 'all'})
				.set($(dom.logo.ele + ' .grp4'), {clearProps: 'all'})
				.set($(dom.landing.cta), {autoAlpha:0, y: +40, scale: 0.8})
				.set($(dom.landing.text), {autoAlpha:0, className: '-=ani-fade4sec'})
				.add(function(){preload.subPixelFix($('#js-land-cta .btn--wide__text'))},0)
				.to($(dom.landing.cta), 0.25, {autoAlpha:1, y: 0, force3D:true, ease:Power4.easeOut})
				.to($(dom.landing.cta), 0.25, {scale: 1, force3D:true, ease:Power4.easeOut})
				.to($(dom.landing.text), 0.2, {autoAlpha:1, force3D:true, ease:Power4.easeOut})
				//.to($(dom.landing.text), 0.1, {alpha:0, force3D:true, delay:2})
			
			.seek(0).pause();
		
	},
	
	init:function(){
		//--------------------------------------------
		//! SAVE IMAGE BUTTON ANIMATION
		//--------------------------------------------
		ani.saveButton = new TimelineMax({ delay:0, repeat:-1})
			.to($(dom.share.saveImgArow),0.5,{y:3,opacity:0.5 })
			.to($(dom.share.saveImgArow),0.5,{y:0,opacity:1})
			.seek(0).pause();

		//alert();
		//////////////////////////////////////////////
		//! PAGES
		//////////////////////////////////////////////
				
		//--------------------------------------------
		//! RECIEVE
		//--------------------------------------------
			ani.thisPage = $('#js-pg-recived');
			
			// OUT
			ani.recieveOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
			
				.to($(dom.recieve.button), 0.15, {scale: 0.8, force3D:true, ease:Power4.easeOut})
				.to($(dom.recieve.button), 0.15, {y: +40, autoAlpha: 0, force3D:true, ease:Power4.easeOut})
				.to($(dom.recieve.text), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
			
			.seek(0).pause();
			
	
			
			
			
		//--------------------------------------------
		//! LANDING
		//--------------------------------------------
			ani.thisPage = $('#js-pg-landing');
			
			// OUT
			ani.landingOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
				
				.to($(dom.landing.text), 0.1, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.landing.cta), 0.1, {scale: 0.8, force3D:true, ease:Power4.easeOut})
				.to($(dom.landing.cta), 0.15, {autoAlpha:0, 7: +80, force3D:true, ease:Power4.easeOut})
				
				.to($(dom.logo.ele + ' .grp1'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp2'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp3'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele + ' .grp4'), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
				.to($(dom.logo.ele), 0.15, {autoAlpha:0, force3D:true, ease:Power4.easeOut})
			
			.seek(0).pause();
			
			
		//--------------------------------------------
		//! GYTRO ICON
		//--------------------------------------------
			
			var gyroSpeed = 0.9;
			var gyroDist = 25;
			var gyroAngle = 30;
			var gyroScale = 1.05;
			
			ani.iconGyro = new TimelineMax({delay:0, repeat:3, onComplete:ani.iconGyroOut})

				.fromTo($(dom.explore.gyro), gyroSpeed, 
					{x: 0, 	rotationY: '0deg', 	scale:1},
					{x: gyroDist, 	rotationY: '-'+gyroAngle+'deg', 	scale:gyroScale, ease: Sine.easeOut, force3D:true})

				.fromTo($(dom.explore.gyro), gyroSpeed, 
					{x: gyroDist, 	rotationY: '-'+gyroAngle+'deg', 	scale:gyroScale},
					{x: 0, 	rotationY: '0deg', 	scale:1,ease: Sine.easeIn, force3D:true})

				.fromTo($(dom.explore.gyro), gyroSpeed, 
					{x: 0, 	rotationY: '0deg', 	scale:1},
					{x: -gyroDist, 	rotationY: gyroAngle+'deg', 	scale:gyroScale, ease: Sine.easeOut, force3D:true})
					
				.fromTo($(dom.explore.gyro), gyroSpeed, 
					{x: -gyroDist, 	rotationY: gyroAngle+'deg', 	scale:gyroScale},
					{x: 0, 	rotationY: '0deg', 	scale:1, ease: Sine.easeIn, force3D:true})
			
			.seek(0).pause();
			
		

		//--------------------------------------------
		//! EXPLORE
		//--------------------------------------------
			ani.thisPage = $('#js-pg-explore');
			
			// OUT
			ani.exploreOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
				
				.staggerTo($('.exploreNav__cta'), 0.75, {autoAlpha: 0, y: +50, force3D:true, ease:Power4.easeOut},0.1)
				
				.to($(dom.explore.text), 0.25, {autoAlpha: 0, force3D:true, ease:Power4.easeOut})
				.to($(dom.explore.gyro), 0.25, {autoAlpha: 0, force3D:true, ease:Power4.easeOut})
				
			
			.seek(0).pause();
			
			// IN
			ani.exploreIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
			
				.set($('.exploreNav__cta'), {autoAlpha: 0, y:0})
				.set($('.exploreNav__cta .btn--wide__middle'), {width: '20px'})
				.set($('.exploreNav__cta .btn--wide__text'), {autoAlpha: 0})
				.set($(dom.explore.text), {autoAlpha: 0, className: '-=ani-fade4sec'})
				.set($(dom.explore.gyro), {x: 0, 	rotationY: '0deg', 	scale:1, autoAlpha: 0, className: '-=ani-fade4sec'})
				.staggerTo($('.exploreNav__cta'), 0.45, {autoAlpha: 1, force3D:true, ease:Power4.easeOut},0.2)
				.staggerTo($('.exploreNav__cta .btn--wide__middle'), 0.25, {width: '100%', force3D:true, ease:Power4.easeOut},0.2)
				.staggerTo($('.exploreNav__cta .btn--wide__text'), 0.25, {autoAlpha: 1, force3D:true, ease:Power4.easeOut}, 0.2)
				.to($(dom.explore.text), 0.25, {autoAlpha: 1, force3D:true, className: '+=ani-fade6sec', ease:Power4.easeOut})
				.to($(dom.explore.gyro), 0.25, {autoAlpha: 1, force3D:true, className: '+=ani-fade6sec', ease:Power4.easeOut}) //
				.add(ani.playGyro, '-=0.25')
				
				
			.seek(0).pause();
			
			
	
		//--------------------------------------------
		//! WRITE
		//--------------------------------------------
			ani.thisPage = dom.page.write;
			
			// OUT
			ani.writeOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
			
				.to($('#js-writeBox'), 1, { scale: 0.8, autoAlpha: 0, force3D:true, ease:Power4.easeOut})
					
			.seek(0).pause();
			
			
			// IN
			ani.writeIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
				
				.set($('#js-writeBox'), {clearProps: 'all'})
				.set($('.writeBox__bkg'), {alpha: 0, fillOpacity: 0, force3D:true})
				.set($('.writeBox__icon--write'), {alpha: 0, y: '-20px', force3D:true})
				.set($('.writeBox__placeholder span'), {alpha: 0})
				
				.to($('.writeBox__bkg'), 0.6, {alpha: 1, force3D:true, ease:Power4.easeOut})
				.to($('.writeBox__bkg'), 0.45, {fillOpacity: 1, force3D:true, ease:Power4.easeOut})
				.to($('.writeBox__icon--write'), 0.45, {alpha: 1, y: '0px', force3D:true, ease:Power4.easeOut})
				.to($('.writeBox__placeholder span'), 0.45, {alpha: 1, force3D:true, ease:Power4.easeOut})
			
			.seek(0).pause();
			
		//--------------------------------------------
		//! PREVIEW
		//--------------------------------------------
			ani.thisPage = dom.page.preview;
			
			// OUT
			ani.previewOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
			
				.to($(dom.preview.text), 1, {autoAlpha:0 ,force3D:true, ease:Power4.easeOut})
			
			.seek(0).pause();
			
			// IN
			ani.previewIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
				//.set($(dom.preview.text), {autoAlpha:0})
				.set($(dom.preview.text), {autoAlpha:0})
				//.set($(dom.preview.text), {autoAlpha: 0, className: '-=ani-fade4sec'})
				.fromTo($(dom.preview.text), 0.3, {autoAlpha:0, force3D:true},{autoAlpha:1 , ease:Power4.easeIN}, "+=0.7")
				.to($(dom.preview.text), 0.9, {autoAlpha:0 , ease:Power4.easeOut}, "+=3")
				//.to($(dom.preview.text), 1, {autoAlpha: 1, force3D:true, className: '+=ani-fade4sec', ease:Power4.easeOut})
			
			.seek(0).pause();
			
		//--------------------------------------------
		//! SHARE
		//--------------------------------------------
			ani.thisPage = dom.page.share;
			
			// OUT
			ani.shareOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
				
				.to( $(dom.share.facebook), 0.25, {y:+5, autoAlpha: 0, force3D:true, ease:Power4.easeOut}, 'share1')
				//.to( $(ani.thisPage + ' .page__shareSpacer'), 0.25, {autoAlpha: 0, force3D:true, ease:Power4.easeOut}, 'share1')
				.to( $(dom.share.copyLink), 0.25,{autoAlpha: 0, y: +5, force3D:true, ease:Power4.easeOut}, 'share1')
				.to( $(dom.share.twitter), 0.25, {autoAlpha: 0, y:+5, force3D:true, ease:Power4.easeOut}, 'share1')
				.to( $(dom.share.saveImg), 0.25, {autoAlpha: 0, y:+5, force3D:true, ease:Power4.easeOut}, 'share1')
				.to( $(ani.thisPage), 0.5, {autoAlpha: 0, ease:Power4.easeOut})
			
			.seek(0).pause();
			
			// IN
			ani.shareIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
				
				.set($(ani.thisPage), {autoAlpha: 0})
				.set($(dom.share.facebook), {y:0, scale: 0.8, autoAlpha: 0})
				//.set($(ani.thisPage + ' .page__shareSpacer'), {autoAlpha: 0})

				.set($(dom.share.saveImg), {autoAlpha: 0, y:+5})
				.set($(dom.share.twitter), {autoAlpha: 0, y:+5})
				.set($(dom.share.copyLink), {autoAlpha: 0, y:+5})
				
				.to($(ani.thisPage), 1, {autoAlpha: 1, force3D:true, ease:Power4.easeOut})
				.to($(dom.share.facebook), 0.75, {scale: 1, autoAlpha: 1, force3D:true, ease:Power4.easeOut})
				//.to($(ani.thisPage + ' .page__shareSpacer'), 0.25, {autoAlpha: 1, force3D:true, ease:Power4.easeOut}, 'share1')
				.to($(dom.share.saveImg), 0.50, {autoAlpha: 1, y:0, force3D:true, ease:Power4.easeOut}, 'share2')
				.to($(dom.share.twitter), 0.50, {autoAlpha: 1, y:0, force3D:true, ease:Power4.easeOut}, 'share1')
				.to($(dom.share.copyLink), 0.50, {autoAlpha: 1, y:0, force3D:true, ease:Power4.easeOut}, 'share1')
			
			.seek(0).pause();
		
	//////////////////////////////////////////////
	//! OBJECTS
	//////////////////////////////////////////////
		
		//--------------------------------------------
		//! EXTRA CONTENT
		//--------------------------------------------
			// IN
			ani.extraIn = new TimelineMax({delay:0, repeat:0, onComplete:page.shown})
			
				.from($('#js-extarContent'), 1, {autoAlpha: 0, force3D:true})
			
			.seek(0).pause();
			
			// OUT
			ani.extraOut = new TimelineMax({delay:0, repeat:0, onComplete: page.in})
			
				.to($('#js-extarContent'), 1, {autoAlpha: 0, force3D:true})
			
			.seek(0).pause();
		
		
		//--------------------------------------------
		//! CTA
		//--------------------------------------------
			ani.ctaIn = new TimelineMax({delay:0, repeat:0})
			
			.seek(0).pause();
		
		
		
		//--------------------------------------------
		//! APPBAR
		//--------------------------------------------
			// IN
			ani.appbarIn = new TimelineMax({delay:0, repeat:0})
				
				
				.set($(dom.navBar.home),{alpha: 0, x: -50, pointerEvents:'none'})//Setup home button Animation
				.fromTo($(dom.navBar.prime.ele), 0.25, 
					{alpha: 0, 	y:+50, 	scale: 0.8}, 
					{alpha: 1, 	y:0, 	scale: 1,	ease:Power4.easeOut}
				)
				//.add(this.addHome.bind(this),  0.25) //Check for home button
				.fromTo($(dom.navBar.back), 0.25, 
					{alpha: 0,	x: +50, 	force3D:true},
					{alpha: 1,	x: 0, 		force3D:true, 	ease:Power4.easeOut}
				)
			.seek(0).pause();
			
			// OUT
			ani.appbarOut = new TimelineMax({delay:0, repeat:0, onComplete:app.navBar.status, onCompleteParams:['show', false]})
			
				.to($(dom.navBar.back), 0.25, {alpha: 0, x: +50, ease:Power4.easeOut})
				//.add(this.removeHome.bind(this),  0) //Check for home button
				.to($(dom.navBar.prime.ele), 0.25, {alpha: 0, y:+50, scale: 0.8, 	force3D:true, 		ease:Power4.easeOut})
			.seek(0).pause();
			
			//changePrimeOut
			ani.changePrimeOut = new TimelineMax({delay:0, repeat:0})
				.fromTo($(dom.navBar.prime.label), 0.15, 
					{alpha:1, 	y:0 }, 
					{alpha: 0, 	y: +20})
			.seek(0).pause();
			//cahngeIn
			ani.changePrimeIn = new TimelineMax({delay:0, repeat:0})
				.fromTo($(dom.navBar.prime.label), 0.15, 
					{alpha:0, 	y:-20}, 
					{alpha: 1, 	y:0})
			.seek(0).pause();
		
	},
	
	playGyro:function(){
		
		
		if (page.tracking.current == 'explore') {
			
			ani.iconGyro.seek(0).play();
		}
	}
};